import { render, staticRenderFns } from "./delivery2.vue?vue&type=template&id=858d8f6c&scoped=true&"
import script from "./delivery2.vue?vue&type=script&lang=js&"
export * from "./delivery2.vue?vue&type=script&lang=js&"
import style0 from "./delivery2.vue?vue&type=style&index=0&id=858d8f6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858d8f6c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
